import { computed } from '@vue/composition-api';
// import { useStore } from '@nuxtjs/composition-api';
// import { State } from '~/data/types/store';

enum FeatureFlag {
  WeekEndStats = 'release-week-end-training-summary'
}

export const useFeatureFlag = () => {
  // const store = useStore<State>();
  const hasAccessToWeekEndStats = computed(() => hasAccess(FeatureFlag.WeekEndStats));

  const hasAccess = (_: FeatureFlag) => true; // store.state.auth.user?.data?.enabled_features.includes(feature) ?? false;

  return {
    hasAccessToWeekEndStats,
  };
};
